import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiConfig";

const PerformanceContext = createContext();
export const usePerformance = () => useContext(PerformanceContext);

export const PerformanceProvider = ({ children }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  // =========================
  // GET ALL REVIEWS (GRID)
  // =========================
  const fetchReviews = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${BASE_URL}/performance-reviews`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();

      if (data.status === 200) {
        setReviews(data.data);
      } else {
        setError(data.message || "Failed to fetch reviews");
      }
    } catch (err) {
      console.error(err);
      setError("Server error while fetching reviews");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // CREATE REVIEW (JSON POST)
  // =========================
  const submitReview = async (payload) => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${BASE_URL}/performance-reviews`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      // =========================
      // SUCCESS INSERT
      // =========================
      if (data.status === 200 || data.status === 201) {
        await fetchReviews(); // refresh grid
        return {
          success: true,
          message: data.message,
        };
      }

      return {
        success: false,
        message: "Unexpected error",
      };

    } catch (err) {
      console.error(err);
      return {
        success: false,
        message: "Server error",
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <PerformanceContext.Provider
      value={{
        reviews,
        loading,
        error,
        fetchReviews,
        submitReview,
      }}
    >
      {children}
    </PerformanceContext.Provider>
  );
};